export enum UserStatus {
    Unathorized,
    NotDefined
}
